import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ spacing }) => ({
  firstGrid: {
    marginTop: 0,
    paddingRight: spacing(2),
    paddingLeft: spacing(2),
  },
  grid: {
    paddingRight: spacing(2),
    paddingLeft: spacing(2),
  },
  infoCard: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: 10,
    padding: 15,
    margin: 20,
    backgroundColor: '#F1F4F9'
  },
  infoCardTextTitle: {
		color: '#1E5168',
		fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 10
	},
	infoCardText: {
		color: '#022A5C',
		fontSize: 15
	},
  establishmentsRenderOption: {
    display: 'flex',
    alignItems: 'center'
  }
}));